import { dev } from 'app/features/web3/web3.config'
import tokenAbi from 'tokenAbi.json'
import Web3 from 'web3'
import { AbiItem } from 'web3-utils'

export function number(web3: Web3, some_numbers: number | string) {
  return web3?.utils.toBN(some_numbers)
}
// eslint-disable-next-line @typescript-eslint/naming-convention
export function _1e18(web3: Web3) {
  return number(web3, 10 ** 18)
}

export async function getTokenPrice(web3: Web3) {
  if (dev) {
    return number(web3, 22793600000000)
  }
  const tokenLpAddress = '0x14acb8fEDB3cD4D089d1742EC0322Dfdc59c7b7c'
  const tokenAddress = '0xBD40E2C830E1066D20E72a0cF2E55a19398752f6'
  const wbnbAddress = '0x2F3AD0cdC8AD20337eb02bD6411b808EE30c7896'
  const busdlpAddress = '0xEe915cF11781c5d1438F198766E766BBC6Ecb5A5'
  const busdAddress = '0xf8867A8946582D7227164f6c70cf115Cc93cbDE5'

  const token = new web3.eth.Contract(tokenAbi as AbiItem[], tokenAddress)
  const wbnb = new web3.eth.Contract(tokenAbi as AbiItem[], wbnbAddress)
  const busd = new web3.eth.Contract(tokenAbi as AbiItem[], busdAddress)

  const tokenAmount = await token.methods.balanceOf(tokenLpAddress).call()
  const wbnbAmount0 = await wbnb.methods.balanceOf(tokenLpAddress).call()

  const tokenPrice = number(web3, wbnbAmount0)
    .mul(_1e18(web3))
    .div(number(web3, tokenAmount))

  console.log(`
  tokenAmount: ${tokenAmount}
  wbnb_amount: ${wbnbAmount0}
  `)
  console.log('tokenPrice', tokenPrice.toString())

  const busdAmount = await busd.methods.balanceOf(busdlpAddress).call()
  const wbnbAmount1 = await wbnb.methods.balanceOf(busdlpAddress).call()

  const busdPrice = number(web3, wbnbAmount1)
    .mul(_1e18(web3))
    .div(number(web3, busdAmount))

  console.log(`
    busdAmount: ${busdAmount}
    wbnb_amount: ${wbnbAmount1}
    `)
  console.log(busdPrice.toString())

  const tokenPriceInBusd = tokenPrice.mul(_1e18(web3)).div(busdPrice)
  console.log('tokenpriceinbusd', tokenPriceInBusd.toString())
  return tokenPriceInBusd
}

export const secondsToDhms = (seconds: number) => {
  const d = Math.floor(seconds / (3600 * 24))
  const h = Math.floor((seconds % (3600 * 24)) / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  // const s = Math.floor(seconds % 60)

  const dDisplay = d > 0 ? d.toString() + (d == 1 ? ' day, ' : ' days, ') : ''
  const hDisplay = h > 0 ? h.toString() + (h == 1 ? ' hour, ' : ' hours, ') : ''
  const mDisplay =
    m > 0 ? m.toString() + (m == 1 ? ' minute ' : ' minutes') : ''
  // const sDisplay = s > 0 ? s.toString() + (s == 1 ? ' second' : ' seconds') : ''
  return dDisplay + hDisplay + mDisplay
}

// export const MAX_INT = 115792089237316195423570985008687907853269984665640564039457584007913129639935
